import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './axiosConfig';
import axios from 'axios';
import { capturePasswordResetToken } from './utils/passwordResetBootstrap';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const startApp = async () => {
  const resetToken = capturePasswordResetToken();
  if (resetToken) {
    try {
      const apiUrl = process.env.REACT_APP_API_URL ?? '';
      await axios.post(`${apiUrl}/api/auth/password-reset/exchange`, { token: resetToken });
    } catch {
      // ResetPassword verifies the resulting cookie and displays the generic
      // invalid-link state if the one-time exchange did not succeed.
    }
  }

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

void startApp();
